export default __webpack_public_path__ + "static/media/fundo_login.5bc594b7.jpg";